import React, { useState, useEffect } from 'react'
import {
  getFiltersEcualizador,
  postMaterialsManager,
  postModelosAplicacion,
  getMaterialsManagerByIdMaterial,
} from '@auteco/services/snopServices'
import CustomInput from '@auteco/components/sharedComponents/CustomInput/CustomInput'
import Select from '@material-ui/core/Select'
import Card from '@auteco/components/sharedComponents/Card/Card'
import CardBody from '@auteco/components/sharedComponents/Card/CardBody'
import { Button } from '@material-ui/core'

import { MaterialsTableShared } from '../../MaterialsTableShared'

import { MaterialsFilters } from '../../MaterialsFilters'

const PageFilters = ({
  materials,
  setMaterials,
  handleViewDetails,
  getUpdatedMaterials,
  savedMaterialsFiltered,
  onSaveMaterialsFiltered,
  loading,
  setLoading,
  filters,
  setFilters,
  filterssaved,
  setFiltersSaved,
  children
}) => {
  const [materialsFiltered, setMaterialsFiltered] = useState(
    savedMaterialsFiltered,
  )
  const [models, setModels] = useState([])
  const [selectedModel, setSelectedModel] = useState('')
  const [inputValue, setInputValue] = useState('')
  const [refreshModels, setRefreshModels] = useState(true)

  const getFilters = async () => {
    setLoading(true)
    const { filtros } = await getFiltersEcualizador()
    setFilters(filtros)
    setLoading(false)
  }

  useEffect(() => {
    if (savedMaterialsFiltered && savedMaterialsFiltered.length > 0) {
      setMaterialsFiltered(savedMaterialsFiltered)
    }
    console.log(savedMaterialsFiltered, 'savedMaterialsFiltered')
  }, [savedMaterialsFiltered])

 
  const handleInputChange = (e) => {
    setInputValue(e.target.value)
  }

  const handleButtonClick = async () => {
    setLoading(true)
    const data = await getMaterialsManagerByIdMaterial(inputValue)
    setMaterialsFiltered(data.materiales)
    setLoading(false)
  }

  const getModelsApplicationModels = async () => {
    setLoading(true)
    const modelsForApplication = await postModelosAplicacion({
      params: {
        materiales: materials.map((material) => material.id.toString()),
      },
    })
    setModels(modelsForApplication.data)
    setLoading(false)
  }

  const getModelsApplicationMaterialsByFilters = async (filtersList) => {
    setLoading(true)
    const datafiltered = await postMaterialsManager({ params: filtersList })
    setFiltersSaved(filtersList)
    await setMaterials(datafiltered.materiales)
    if (materials && materials.length > 0) {
      getModelsApplicationModels()
    }
    setMaterialsFiltered(datafiltered.materiales)
    setLoading(false)
  }

  const getModelsApplicationMaterialsByFiltersSaved = async () => {
    if (filterssaved) {
      setLoading(true)
      const datafiltered = await postMaterialsManager({ params: filterssaved })
      await setMaterials(datafiltered.materiales)
      if (materials && materials.length > 0) {
        getModelsApplicationModels()
      }
      setMaterialsFiltered(datafiltered.materiales)
      setLoading(false)
    }
  }

  function getIdsMaterialsByModel(modelText) {
    const modelFinded = models.find(
      (item) => item.modelo_aplicacion === modelText,
    )

    if (!modelFinded) {
      return []
    }

    const ids = modelFinded.materiales.split(',').map(Number)
    const idsUnicos = [...new Set(ids)]
    return idsUnicos.sort((a, b) => a - b)
  }

  function getMaterialsByModel(modelo) {
    const filtro = getIdsMaterialsByModel(modelo)
    if (!filtro) {
      return materials
    }

    const idsAFiltrar = filtro

    const materialsLL = materials.filter((material) =>
      idsAFiltrar.map(String).includes(String(material.id)),
    )
    return materialsLL
  }

  const handleModelChange = (event) => {
    if (event.target.value === 'Filtrar por modelo') {
      setMaterialsFiltered(materials)
      setSelectedModel('Filtrar por modelo')
      return
    }
    const modelSelected = event.target.value
    setSelectedModel(modelSelected)
    const materialsFiltereds = getMaterialsByModel(modelSelected)
    setMaterialsFiltered(materialsFiltereds)
  }

  const handleFilterMaterials = async ({ form }) => {
    setRefreshModels(true)
    await getModelsApplicationMaterialsByFilters(form)
  }

  useEffect(() => {
    onSaveMaterialsFiltered(materialsFiltered)
  }, [materialsFiltered])

  useEffect(() => {
    getFilters()
  }, [])

  useEffect(() => {
    if (materials && materials.length > 0 && refreshModels) {
      getModelsApplicationModels()
      setRefreshModels(false)
    }
  }, [materials])
  
  // useEffect(() => {
  //   if (materialChanged > 0) {
  //     getModelsApplicationMaterialsByFiltersSaved()
  //   }
  // }, [materialChanged])

  return (
    <>
      {filters.length > 0 ? (
        <MaterialsFilters filters={filters} onFilter={handleFilterMaterials} />
      ) : (
        <h4 style={{ padding: '20px' }}>Cargando ⏳</h4>
      )}

      {materialsFiltered && materialsFiltered.length > 0 && (
        <>
          <Card>
            <CardBody>
              <div style={{ width: '250px', marginBottom: '30px' }}>
                <Select
                  disabled={loading}
                  value={selectedModel || 'Filtrar por modelo'}
                  onChange={handleModelChange}
                >
                  <option value="Filtrar por modelo">Filtrar por modelo</option>
                  {models && models.map((model) => (
                    <option
                      key={model.modelo_aplicacion}
                      value={model.modelo_aplicacion}
                    >
                      {model.modelo_aplicacion}
                    </option>
                  ))}
                </Select>
                <div>
                  <CustomInput
                    labelText="Filtrar por  material"
                    id="cedula"
                    value={inputValue}
                    required
                    disabled={loading}
                    formControlProps={{
                      fullWidth: true,
                      required: true,
                    }}
                    inputProps={{
                      onChange: handleInputChange,
                      autoComplete: 'on',
                    }}
                    helperText={{}}
                  />
                  <Button
                    variant="contained"
                    color="warning"
                    disabled={loading}
                    onClick={handleButtonClick}
                  >
                    Filtrar
                  </Button>
                </div>
              </div>
            </CardBody>
          </Card>
        </>
      )}
      {children}
      <MaterialsTableShared
        title="Listado de materiales"
        materials={materials}
        handleViewDetails={handleViewDetails}
        getUpdatedMaterials={getUpdatedMaterials}
        loading={loading}
        getModelsApplicationMaterialsByFiltersSaved={
          getModelsApplicationMaterialsByFiltersSaved
        }
        setMaterials={setMaterials}
        setMaterialsFiltered={setMaterialsFiltered}
        setRefreshModels={setRefreshModels}
      />
    </>
  )
}

export default PageFilters
